// Page-specific configurations for Activity Logs and Reports

export const PAGE_CONFIGS = {
  'Employee Master': {
    activityTypes: [
      'Employee Created', 'Employee Updated', 'Employee Deleted',
      'Profile Updated', 'Document Uploaded', 'Status Changed'
    ],
    reportTypes: [
      'Employee Directory Report', 'New Joiners Report', 'Employee Status Report',
      'Department Wise Report', 'Employee Profile Report', 'Document Status Report'
    ]
  },
  
  'Asset Management': {
    activityTypes: [
      'Asset Assigned', 'Asset Returned', 'Asset Created',
      'Asset Updated', 'Asset Maintenance', 'Asset Disposed'
    ],
    reportTypes: [
      'Asset Allocation Report', 'Asset Utilization Report', 'Asset Maintenance Report',
      'Asset Depreciation Report', 'Asset Audit Report', 'Asset Cost Analysis'
    ]
  },
  
  'User Management': {
    activityTypes: [
      'User Created', 'User Updated', 'User Deactivated',
      'Role Assigned', 'Permission Changed', 'Password Reset'
    ],
    reportTypes: [
      'User Activity Report', 'Role Assignment Report', 'User Access Report',
      'Permission Audit Report', 'User Registration Report', 'Inactive Users Report'
    ]
  },
  
  'Payroll Management': {
    activityTypes: [
      'Payroll Processed', 'Salary Updated', 'Bonus Added',
      'Deduction Applied', 'Payslip Generated', 'Tax Calculated'
    ],
    reportTypes: [
      'Monthly Payroll Report', 'Salary Structure Report', 'Tax Deduction Report',
      'Bonus Distribution Report', 'Payroll Summary Report', 'Compliance Report'
    ]
  },
  
  'Leave Management': {
    activityTypes: [
      'Leave Applied', 'Leave Approved', 'Leave Rejected',
      'Leave Cancelled', 'Leave Balance Updated', 'Holiday Added'
    ],
    reportTypes: [
      'Leave Balance Report', 'Leave Application Report', 'Department Leave Report',
      'Leave Trend Report', 'Holiday Calendar Report', 'Leave Compliance Report'
    ]
  },
  
  'Attendance Management': {
    activityTypes: [
      'Attendance Marked', 'Late Entry Recorded', 'Early Exit Recorded',
      'Overtime Approved', 'Attendance Corrected', 'Shift Changed'
    ],
    reportTypes: [
      'Daily Attendance Report', 'Monthly Attendance Report', 'Overtime Report',
      'Late Coming Report', 'Attendance Summary Report', 'Shift Wise Report'
    ]
  },
  
  'Performance Management': {
    activityTypes: [
      'Goal Set', 'Review Completed', 'Rating Updated',
      'Feedback Given', 'Appraisal Initiated', 'Performance Plan Created'
    ],
    reportTypes: [
      'Performance Review Report', 'Goal Achievement Report', 'Rating Distribution Report',
      'Appraisal Summary Report', 'Performance Trend Report', 'Team Performance Report'
    ]
  },
  
  'Training Management': {
    activityTypes: [
      'Training Assigned', 'Training Completed', 'Training Cancelled',
      'Certificate Issued', 'Training Feedback', 'Course Created'
    ],
    reportTypes: [
      'Training Completion Report', 'Training Effectiveness Report', 'Skill Gap Report',
      'Training Cost Report', 'Certification Report', 'Training Calendar Report'
    ]
  },
  
  'Recruitment Management': {
    activityTypes: [
      'Job Posted', 'Application Received', 'Interview Scheduled',
      'Candidate Shortlisted', 'Offer Extended', 'Candidate Hired'
    ],
    reportTypes: [
      'Recruitment Pipeline Report', 'Candidate Source Report', 'Interview Report',
      'Hiring Metrics Report', 'Time to Hire Report', 'Recruitment Cost Report'
    ]
  },
  
  'Policy Management': {
    activityTypes: [
      'Policy Created', 'Policy Updated', 'Policy Published',
      'Policy Acknowledged', 'Policy Archived', 'Compliance Checked'
    ],
    reportTypes: [
      'Policy Compliance Report', 'Policy Acknowledgment Report', 'Policy Audit Report',
      'Policy Effectiveness Report', 'Policy Update Report', 'Compliance Status Report'
    ]
  }
};

export const getPageConfig = (moduleName) => {
  return PAGE_CONFIGS[moduleName] || {
    activityTypes: ['Record Created', 'Record Updated', 'Record Deleted', 'Data Exported', 'Settings Changed'],
    reportTypes: ['Daily Report', 'Weekly Report', 'Monthly Report', 'Summary Report', 'Audit Report']
  };
};